(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contrelov-cart"] && !Shopify.designMode) return;
  try {
    
  if (window.Shopify && Shopify.designMode) {
    /* editor preview should not mutate the cart */
  } else {
    const root = document.querySelector('[id^="ContrelovCart-"]');
    if (root && !root.dataset.contrelovStarted) {
      root.dataset.contrelovStarted = 'true';
      const variantId = Number(root.dataset.variantId);
      const discountCode = (root.dataset.discount || '').trim();

      const refreshCart = () => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.refreshFromCache === 'function') {
          return drawer.refreshFromCache();
        }
        return Promise.resolve();
      };

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then(async (cart) => {
          const hasGift = cart.items.some((item) => item.variant_id === variantId);
          const codes = (cart.discount_codes || []).map((entry) => entry.code);
          const hasDiscount = codes.some((code) => code.toUpperCase() === discountCode.toUpperCase());
          let changed = false;

          if (discountCode) {
            try {
              sessionStorage.setItem('appliedDiscount', discountCode);
            } catch (err) {}
          }

          if (!hasGift && variantId) {
            const addResponse = await fetch(window.routes.cart_add_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
            });
            if (addResponse.ok) changed = true;
          }

          if (discountCode && !hasDiscount) {
            await fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' });

            const nextCodes = codes.concat(discountCode);
            const discountResponse = await fetch(window.routes.cart_update_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: nextCodes.join(',') }),
            });
            if (discountResponse.ok) changed = true;
          }

          if (changed) await refreshCart();
        })
        .catch(() => {});
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-popup')) {
    customElements.define(
      'promo-popup',
      class PromoPopup extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.overlay = this.querySelector('[data-promo-overlay]');
          this.dialog = this.querySelector('[data-promo-dialog]');
          this.storageKey = this.getAttribute('data-storage-key') || 'lov_dia_cliente_popup2';
          this.hours = Math.max(1, Number(this.getAttribute('data-hours') || 6));
          this.delay = Math.max(0, Number(this.getAttribute('data-delay') || 3)) * 1000;
          this.lastFocus = null;

          this.onClick = this.onClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.addEventListener('click', this.onClick);
          this.start();
        }

        disconnectedCallback() {
          if (this.timer) clearTimeout(this.timer);
          document.removeEventListener('keydown', this.onKeydown);
          document.body.style.overflow = '';
        }

        start() {
          if (this.hasAttribute('data-design-mode')) {
            this.open();
            return;
          }
          if (!this.canShow()) return;
          this.timer = setTimeout(() => this.open(), this.delay);
        }

        canShow() {
          try {
            const raw = window.localStorage.getItem(this.storageKey);
            if (!raw) return true;
            const seenAt = Number(raw);
            if (!Number.isFinite(seenAt)) return true;
            return Date.now() - seenAt >= this.hours * 60 * 60 * 1000;
          } catch (err) {
            return true;
          }
        }

        markSeen() {
          try {
            window.localStorage.setItem(this.storageKey, String(Date.now()));
          } catch (err) {}
        }

        onClick(event) {
          if (event.target.closest('[data-promo-close]')) {
            this.close();
            return;
          }
          if (event.target.closest('[data-promo-overlay]') && !event.target.closest('[data-promo-dialog]')) {
            this.close();
            return;
          }
          if (event.target.closest('[data-promo-cta]')) {
            this.markSeen();
          }
        }

        onKeydown(event) {
          if (event.key === 'Escape') this.close();
        }

        open() {
          if (!this.overlay || !this.overlay.hidden) return;
          this.markSeen();
          this.lastFocus = document.activeElement;
          this.overlay.hidden = false;
          document.body.style.overflow = 'hidden';
          document.addEventListener('keydown', this.onKeydown);
          if (this.dialog) this.dialog.focus();
        }

        close() {
          if (!this.overlay || this.overlay.hidden) return;
          this.overlay.hidden = true;
          document.body.style.overflow = '';
          document.removeEventListener('keydown', this.onKeydown);
          if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
